import styled from 'styled-components'

const SplashBackground = styled.div`
  overflow: hidden;
  background: linear-gradient(209deg, rgba(0,166,153,1) 36%, rgba(211,250,247,1) 100%);
  height: 100vh;
`;

const AirbnbButton = styled.div`
    background-color: #ff5a5f;
    border: none;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    border-radius: 18px;
    padding: 10px 40px;
`

const ImagePlaceHolder = styled.div`
  width:100%;
  height: 255px;
  overflow: visible;
  background-color: rgba(0, 153, 255, 0.17);
`;

export {
    SplashBackground,
    ImagePlaceHolder,
    AirbnbButton
}